import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

const InfoEventDetails = ({
    title,
    starts
}) => {
    const date = moment.tz(starts, window.currentCityTimezone);

    return (
        <div className="SH-InfoEventDetails">
            <h1 className="heading-sm">{title}</h1>
            <p>{date.format('ddd, MMM D, YYYY')}<span>{date.format('h:mm a')}</span></p>
        </div>
    );
};

InfoEventDetails.propTypes = {
    title: PropTypes.string.isRequired,
    starts: PropTypes.string.isRequired
};

export default InfoEventDetails;



// WEBPACK FOOTER //
// ./widget/src/js/components/header/InfoEventDetails.jsx